import { Box, Typography } from '@mui/material';

import theme from 'src/style-system/theme';
import Header from '@components/Header';

import { useStyles } from './useStyles';

interface IHeroSectionComponent {
  slice: any;
}

const HeroSectionComponent = ({ slice }: IHeroSectionComponent) => {
  const { title, desktopbackgroungimg, mobilebackgroundimg } =
    slice?.primary || {};
  const { url: dtUrl } = desktopbackgroungimg || {};
  const { url: mbUrl } = mobilebackgroundimg || {};

  const classes = useStyles();

  return (
    <Box
      sx={{
        backgroundImage: `url(${dtUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        [theme.breakpoints.down('md')]: {
          backgroundImage: `url(${mbUrl})`,
        },
      }}
    >
      <Header
        isBackground={false}
        fill={theme.palette.turmeric.main}
        TCCLogoFill={theme.palette.turmeric.main}
      />
      <Box className={classes.title}>
        <Typography variant="h1" align="center" color="garamMasala.main">
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSectionComponent;
